import { render, staticRenderFns } from "./UnitBubble.vue?vue&type=template&id=001163b6&scoped=true"
import script from "./UnitBubble.vue?vue&type=script&lang=js"
export * from "./UnitBubble.vue?vue&type=script&lang=js"
import style0 from "./UnitBubble.vue?vue&type=style&index=0&id=001163b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001163b6",
  null
  
)

export default component.exports